import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import "./index.css"
import { Willow, And, Blake } from "./SplitLogo";
import gsap from "gsap";
import Link from "../../utils/link";
import MobileLogo from "./MobileLogo";
import CloseCross from "./CloseCross";
import { graphql, useStaticQuery } from "gatsby";
import useStoryblok from "../../lib/storyblok";

const getXDelta = (startElement, endElement) => {

    const startRect = startElement.getBoundingClientRect()
    const endRect = endElement.getBoundingClientRect()

    const deltaX = endRect.left - startRect.left

    return deltaX
}

const moveElementX = (start, end, tl) => {
    const startElement = document.querySelector(start)
    const endElement = document.querySelector(end)

    const deltaX = getXDelta(startElement, endElement)

    tl.to(startElement, { x: deltaX, duration: 1, ease: "power1.inOut" }, 1)

}

/* 
const Header = () => {




    useEffect(() => {

        // get .clone .willow x position

        const tl = gsap.timeline({
            paused: true
        })

        tl.to(".inner", {opacity: 1, duration: 0.5}, 0)

        moveElementX(".inner .willow", ".clone .willow", tl)
        moveElementX(".inner .blake", ".clone .blake", tl)

        tl.to(".clone", {opacity: 1, duration: 0}, 2)
        tl.to(".inner", {opacity: 0, duration: 0.5}, 2)

        tl.play()


    }, [])


    return (
        <header className="absolute inset-0 z-50 text-white nav-bar py-5 h-fit">
            <div className="relative">
            <nav className="width flex items-center justify-center inner opacity-0 pointer-events-none">
                <Willow />
                <And />
                <Blake />
            </nav>
            <nav className="width flex items-center justify-between absolute inset-0 clone opacity-0">
                <Willow />
                <And />
                <Blake />
            </nav>

            </div>
        </header>
    )
}

*/

const CompareLink = (link1, link2) => {
    // Trim leading and trailing whitespaces from the links
    const cleanLink1 = link1.trim();
    const cleanLink2 = link2.trim();
  
    // Remove leading and trailing slashes from the links
    const trimmedLink1 = cleanLink1.replace(/^\/+|\/+$/g, '');
    const trimmedLink2 = cleanLink2.replace(/^\/+|\/+$/g, '');
  
    // Ignore query strings by removing everything after the "?" character
    const withoutQueryLink1 = trimmedLink1.split('?')[0];
    const withoutQueryLink2 = trimmedLink2.split('?')[0];
  
    return withoutQueryLink1 === withoutQueryLink2;
  };

const HeaderLinkGroup = (props) => {
    return (

        <ol className={`flex space-x-20 link-groups ${props.isWhite ? `text-white` : ``}`}>

            {props.group.map((item, index) => {


                return (
                    <li key={`header-link-group-${props.pos}-${index}`}>
                        <Link to={item.link.cached_url} className={`hover-underline-animation ${CompareLink(item.link.cached_url, props.location) ? `font-semibold active` : ``}`}>
                            {item.title}
                        </Link>
                    </li>
                )
            })}

        </ol>

    )
}

const HeaderWrapper = (props) => {


    const data = useStaticQuery(graphql`
        query NavQuery {
            storyblokEntry(full_slug: { eq: "header" }) {
            id
            content
            }
        }
    `);
    

    const entry = useStoryblok(data.storyblokEntry)

    const content = entry.content


    const mobileMenu = useRef(null)
    const desktopMenu = useRef(null)
    const [hasSetup, setHasSetup] = useState(false)
    const LOGO_GAP = 15


    const MobileMenu = [
        ...content.left_column,
        ...content.right_column
    ]

    const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

    const tl = useRef(gsap.timeline({ defaults: { ease: "power2.inOut" }}).reverse());

    useLayoutEffect(() => {
        tl.current.fromTo(mobileMenu.current, { x: "-100%" }, { x: 0, duration: 0.5 }, 0)

        // stagger links

        tl.current.fromTo(mobileMenu.current.querySelectorAll(".slide-up"), { opacity: 0, y: -20 }, { opacity: 1, y: 0, duration: 0.5, stagger: 0.1 }, 0.5)
        tl.current.fromTo(mobileMenu.current.querySelectorAll(".bottom-box"), { opacity: 0 }, { opacity: 1, duration: 0.5, stagger: 0.1 })

    }, []);



    useEffect(() => {
        tl.current.reversed(!mobileMenuOpen);
        // disable scroll when mobile menu is open
        if (mobileMenuOpen) {
            document.body.style.overflow = "hidden"
            tl.current.play()
            setDelayColorChange(true)

        } else {
            if(hasSetup){
                setDelayColorChange(true)

                // in 1300ms, set delayColorChange to false

            }
            document.body.style.overflow = "auto"
            tl.current.reverse()
            if (hasSetup) {
                setTimeout(() => {
                    setDelayColorChange(false)
                }, 1300)
            }
        }
        setHasSetup(true)

    }, [mobileMenuOpen])

    useLayoutEffect(() => {

        if (props.animateLogo) {

            // set .willow .and .blake to opacity 1

            // position .willow so it's right next to .and, have 15px gap
            const willow = desktopMenu.current.querySelector(".willow")
            const and = desktopMenu.current.querySelector(".and")
            const blake = desktopMenu.current.querySelector(".blake")
            const linkGroups = desktopMenu.current.querySelectorAll(".animate-logo .link-groups")

            gsap.to([willow, and, blake], { opacity: 1, duration: 0.3 })

            const willowRect = willow.getBoundingClientRect()
            const andRect = and.getBoundingClientRect()
            const deltaX = andRect.left - willowRect.right - LOGO_GAP
            gsap.set(willow, { x: deltaX })
            // set .blake to be right next to .and
            const blakeRect = blake.getBoundingClientRect()
            const deltaX2 = andRect.right - blakeRect.left + LOGO_GAP
            gsap.set(blake, { x: deltaX2 })

            const logoAnimation = gsap.timeline()
            logoAnimation.to(willow, { x: 0, duration: 1, ease: "slowMo.ease( 0.7 0.7, 0.7 0.7, false)" }, 2)
            logoAnimation.to(blake, { x: 0, duration: 1, ease: "slowMo.ease( 0.7 0.7, 0.7 0.7, false)" }, 2)
            logoAnimation.to(linkGroups, { opacity: 1, duration: 0.5 }, 2.5)
            logoAnimation.play()

            // set .animate-logo .link-groups to opacity 1



        }
    }, [props.animateLogo])


    const [navStyle, setNavStyle] = useState(props.navStyle)
    const [isBlack, setIsBlack] = useState(navStyle != "white" ? true : false)


    useEffect(() => {
        // listen for nav style change
        window.addEventListener("navStyleChange", (e) => {
            if (e.detail.path != window.location.pathname) return
            setNavStyle(e.detail.navStyle)
            setIsBlack(e.detail.navStyle != "white" ? true : false)
        })
    }, [])


    // handle mobile menu item click

    const handleMobileMenuItemClick = (e) => {
        setMobileMenuOpen(false)
    }

    const [delayColorChange, setDelayColorChange] = useState(false)

    return (
        <>
            <header className={`absolute inset-0 z-index-fix z-50 nav-bar py-[23px] lg:py-5 h-fit transition-colors duration-500 ${delayColorChange ? `mobile:delay-[1.3s]` : ``} ${(isBlack || mobileMenuOpen) ? `text-black` : `text-white`} ${props.animateLogo ? `animate-logo` : ``} overflow-hidden`} ref={desktopMenu}>
                <nav className="width lg:grid-cols-6 hidden lg:grid">
                    <div className={`flex justify-start ${navStyle == 'white-black' ? `text-white` : ``}`}>
                        <Link to="/"><Willow /></Link>
                    </div>
                    <div className="flex justify-center col-span-4 items-center space-x-20 inner-header">
                        <HeaderLinkGroup group={content.left_column} pos={`left`} location={props.location} isWhite={navStyle == `white-black`} />
                        <Link to="/" className='relative'>
                            <And navStyle={navStyle} />
                        </Link>
                        <HeaderLinkGroup group={content.right_column} pos={`right`} location={props.location} isWhite={navStyle == `black-white`} />

                    </div>
                    <div className={`flex justify-end ${navStyle == 'black-white' ? `text-white` : ``}`}>
                        <Link to="/"><Blake /></Link>
                    </div>
                </nav>
                <nav className="lg:hidden flex width justify-between relative items-end">
                    <Link to="/" onClick={handleMobileMenuItemClick}>
                        <MobileLogo />
                        <span className="sr-only">Home</span>
                    </Link>

                    <button className={`uppercase text-xs font-semibold overflow-x-visible min-w-[70px] relative mobile-menu-button ${mobileMenuOpen ? `open` : `closed`}`} onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
                        <div className="relative overflow-y-hidden">
                            <span className="menu float-right leading-[1]">
                                Menu
                            </span>
                            <div className="close absolute right-0 w-fit top-0 flex space-x-[6px] leading-[1]">
                                <span>Close</span> <CloseCross />
                            </div>
                        </div>
                    </button>
                </nav>
            </header>
            <nav className={`fixed inset-0 h-full w-full bg-off-white z-40 lg:hidden ${!hasSetup ? `hidden` : ``} ${mobileMenuOpen ? `` : `pointer-events-none`} flex flex-col justify-between`} ref={mobileMenu} aria-label="Mobile navigation menu"
                role="navigation"
                aria-hidden={!mobileMenuOpen}
                aria-expanded={mobileMenuOpen}
            >

                <ol className="mt-mobile-menu width space-y-2">
                    {MobileMenu.map((item, index) => {
                        return (
                            <li key={`header-link-group-${index}`} className="overflow-hidden">
                                <Link to={item.link.cached_url} onClick={handleMobileMenuItemClick}>
                                    <span className="text-53 font-serif slide-up">{item.title}</span>
                                </Link>
                            </li>
                        )
                    })}
                </ol>

                <div className="width flex space-x-11 pb-20 text-xs">
                    <ol className="flex flex-col justify-start bottom-box">
                        {content.mobile_sub_links.map((item, index) => {
                            return (
                                <li key={`socials-${index}`}>
                                    <Link to={item.link.cached_url}>
                                        {item.title}
                                    </Link>
                                </li>
                            )
                        })}
                    </ol>

                    <div className="bottom-box" dangerouslySetInnerHTML={{__html: content.mobile_contact_info}}>
                       

                    </div>
                </div>

            </nav>
        </>
    )
}


export default HeaderWrapper